<template>
  <div class="pa-5">
    <v-card shaped class="elevation-10">
      <v-card-title>{{ `แบบฟอร์ม${form_title}เอกสาร` }}</v-card-title>      
      <v-card-text class="pt-0">
        <v-text-field v-model="form.name_th" outlined dense label="ชื่อเอกสาร"></v-text-field>
        <v-select v-model="form.document_type_id" outlined dense :items="document_types" item-text="name_th" item-value="id" label="ประเภทเอกสาร"></v-select>
        
        <v-subheader class="px-0">ผู้ที่เกี่ยวข้อง</v-subheader>
        <v-row class="mx-5">
          <v-checkbox v-model="form.concerned_person" class="mr-2 py-0 my-0" v-for="type in staff_types" :key="type.id" :value="type.id" :label="type.name_th"></v-checkbox>
        </v-row>

        <v-subheader class="px-0">สถานะ</v-subheader>
        <v-radio-group class="mx-5 py-0 my-0" v-model="form.status" row>
          <v-radio v-for="status in statuses" :key="status.val" :value="status.val" :label="status.name"></v-radio>
        </v-radio-group>

        <v-subheader class="px-0">วันที่ดำเนินการ(ไม่มีไม่ต้องใส่)</v-subheader>
        <v-row>
          <v-col cols="12" md="4">
            <v-menu
              v-model="announcement"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  dense
                  v-model="form.announcement_date"
                  label="วันที่ประกาศ"
                  prepend-icon="mdi-calendar"
                  :append-icon="form.announcement_date ? 'mdi-close' : ''"
                  @click:append="form.announcement_date = ''"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.announcement_date"
                no-title
                scrollable
                @input="announcement = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="4">
            <v-menu
              v-model="effective"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  dense
                  v-model="form.effective_date"
                  label="วันที่บังคับใช้"
                  prepend-icon="mdi-calendar"
                  :append-icon="form.effective_date ? 'mdi-close' : ''"
                  @click:append="form.effective_date = ''"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.effective_date"
                no-title
                scrollable
                @input="effective = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="4">
            <v-menu
              v-model="cancel"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  outlined
                  dense
                  v-model="form.cancel_date"
                  label="วันที่ยกเลิก"
                  prepend-icon="mdi-calendar"
                  :append-icon="form.cancel_date ? 'mdi-close' : ''"
                  @click:append="form.cancel_date = ''"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.cancel_date"
                no-title
                scrollable
                @input="cancel = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-file-input v-model="form.file" class="mt-5" dense outlined accept="application/pdf" :label="form_type === 'EDIT' ? 'แนบไฟล์ใหม่' : 'แนบไฟล์'"></v-file-input>

      </v-card-text>
      <v-card-actions class="d-flex flex-row justify-center">
        <v-btn color="success" @click="submit">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    form: {
      document_type_id: '',
      name_th: '',
      concerned_person: [],
      status: 0,
      announcement_date: '',
      effective_date: '',
      cancel_date: '',
      file: null
    },
    announcement: false,
    effective: false,
    cancel: false,
  }),
  computed: {
    form_type() { return this.$route.meta.form_type },
    form_title() { return this.$route.meta.form_title },
    document_types() { return this.$store.state.document.document_types },
    staff_types() { return this.$store.state.document.staff_types },
    statuses() {
      return [
        { name: 'ไม่ระบุ', val: 0 },
        { name: 'บังคับใช้', val: 1 },
        { name: 'ยกเลิก', val: 2 },
      ]
    }
  },
  mounted() {
    if(this.form_type === 'EDIT') {
      this.$store.dispatch('document/edit', this.$route.params.id)
        .then(resp => {
          const { document } = resp;
          this.form = {
            id: document.id,
            document_type_id: document.document_type_id,
            name_th: document.name_th,
            concerned_person: document.concerned_person.split(',').map(item => +item),
            status: document.status,
            announcement_date: document.announcement_date ? document.announcement_date.substr(0, 10) : '',
            effective_date: document.effective_date ? document.effective_date.substr(0, 10) : '',
            cancel_date: document.cancel_date ? document.cancel_date.substr(0, 10) : ''
          }
        });
    }
  },
  methods: {
    submit() {
      this.$store.dispatch(`${this.form_type === 'CREATE' ? 'document/store' : 'document/update'}`, this.createFormData(this.form)).then(() => {
        this.$router.push({ name: 'DocumentList' });
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: 'บันทึกข้อมูลสำเร็จ'
        });
      }).catch(() => {
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'error',
          message: 'เกิดข้อผิดพลาดบางอย่าง'
        });
      });
    },
		createFormData(form) {
      let formData = new FormData;
      
      if(form.id) {
        formData.append('id', form.id);
      }

      formData.append('document_type_id', form.document_type_id);
      formData.append('name_th', form.name_th);
      formData.append('status', form.status);
      formData.append('announcement_date', form.announcement_date);
      formData.append('effective_date', form.effective_date);
      formData.append('cancel_date', form.cancel_date);
      formData.append('file', form.file);
      
      form.concerned_person.forEach(item => {
        formData.append('concerned_person[]', item);
      });
      
			return formData;
    }
  }
}
</script>

<style lang="scss">
  .cover-zone {
    border: 2px dashed;
    cursor: pointer;
  }
  .img-fluid {
    width: 100%;
  }
</style>